import React from 'react';
import _ from 'lodash';
import { Modal, Form, Button, Feed, Image, Icon } from 'semantic-ui-react';
import { makeDebugger } from 'lib';

import history from '../../lib/history';
import TagDropdown from '../TagDropdown';
import IconButton from '../IconButtons';
import Collapsable from '../Collapsable';
import './style.css';

const debug = makeDebugger('Edit Panel Modal')

const EditPanelModal = (props) => {
  debug('Rendering...')
  const renderEntry = (entry, id) => {
    return (
      <Feed.Event key={id}>
        <Feed.Label>
          <Image src={entry.faviconUrl} />
        </Feed.Label>
        <Feed.Content onClick={() => window.open(entry.url, '_blank')}>
          {entry.title}
        </Feed.Content>
        <Icon name='close' onClick={() => props.onRemove(entry.url)}/>
      </Feed.Event>
    )
  }

  const handleClose = () => {
    this.submitButton && this.submitButton.focus();
  }

  const handleCancel = () => {
    props.onCancel && props.onCancel();
    history.goBack();
  }

  const handleDone = () => {
    props.onDone && props.onDone(props.tagsSelected, props.entries);
    history.goBack();
  }

  return (
    <Modal
      open={true}
      className="scrolling edit-panel-modal small"
      dimmer={'inverted'}>
      <Collapsable handleDone={handleDone} />
      <IconButton
        name="cancel"
        className="modal-cancel-button"
        onClick={handleCancel}
      />
      <Modal.Content>
        <Form>
          <Form.Group>
            <TagDropdown
              allowAdditions={true}
              handleTagOptionCreate={props.handleTagOptionCreate}
              handleTagsUpdated={props.handleTagsUpdated}
              tagOptions={props.tagOptions}
              tagsSelected={props.tagsSelected}
              placeholder={"Add Tags"}
              enableDoneAction={true}
              // enableCloseAction={true}
              handleDone={handleDone}
              handleClose={handleClose}/>
            <div className="done-button-container">
              <Button
                ref={(b) => {
                  this.submitButton = b
                  if (this.submitButton && props.tagsSelected.length === 0)
                      this.submitButton.focus()
                }}
                primary
                icon='checkmark'
                onClick={handleDone}
                labelPosition='right'
                content='Add'
                type='submit'>
              </Button>
            </div>
          </Form.Group>
        </Form>
        <Feed>
          {_.map(props.entries, (entry, i) => {
            return renderEntry(entry, i)
          })}
        </Feed>
      </Modal.Content>
    </Modal>
  );
}

export default EditPanelModal;



// WEBPACK FOOTER //
// ./src/components/EditPanelModal/index.js